'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var videoPlayer = function () {
  function videoPlayer($element) {
    _classCallCheck(this, videoPlayer);

    this.$playerButton = $element;
    this.$video = this.$playerButton.querySelector('.js-videoPlayer_video');
    this.init();
  }

  // プレイヤーの再生・停止


  _createClass(videoPlayer, [{
    key: 'playerControl',
    value: function playerControl() {
      console.log('click', this.$video.paused);
      if (this.$video.paused) {
        this.$video.play();
        this.$playerButton.classList.add('is-playing');
      } else {
        this.$video.pause();
        this.$playerButton.classList.remove('is-playing');
      }
    }
  }, {
    key: 'init',
    value: function init() {
      this.$playerButton.addEventListener('click', this.playerControl.bind(this));
    }
  }]);

  return videoPlayer;
}();

document.addEventListener('DOMContentLoaded', function () {
  var $playerButton = document.querySelectorAll('.js-videoPlayer');
  $playerButton.forEach(function ($element) {
    new videoPlayer($element);
  });
});